import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';
import styled from 'styled-components';

export default function QuestionType6(props) {
  const { question } = props;

  return (
    <QuestionGroup>
      <div className="h7 text-primary">{question.name}</div>
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;